// Site-wide Areas tab — leaf under SiteLayout. Per-floor area management
// still lives under each floor (FloorDetailPage); this is the read-across view.

import { createFileRoute } from "@tanstack/react-router";

import { SiteAreasPanel } from "../features/areas/SiteAreasPanel";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/sites/$siteSlug/areas",
)({
  component: SiteAreasRoute,
});

function SiteAreasRoute() {
  const { accountSlug, tenantSlug, siteSlug } = Route.useParams();
  return (
    <SiteAreasPanel
      accountSlug={accountSlug}
      tenantSlug={tenantSlug}
      siteSlug={siteSlug}
    />
  );
}
